import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphProjectsOverview as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphProjectsOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphProjectsOverview: React.FC<ParagraphProjectsOverviewProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="Paragraph ParagraphProjectsOverview">
      <Container>
        <h2 className="visually-hidden">{t('content_types.project.subheading')}</h2>
        <View
          id="projects_filtered"
          display="projects_filtered"
        />
      </Container>
    </div>
  );
};

export default ParagraphProjectsOverview;
